import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateBook from "../../../../Controllers/Admin/SchoolLibrary/CreateBook";
import GetSingleBook from "../../../../Controllers/Admin/SchoolLibrary/GetSingleBook";
import UpdateBook from "../../../../Controllers/Admin/SchoolLibrary/UpdateBook";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function AddBookViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [SchoolID, setSchoolID] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [BookIDD, setBookIDD] = useState("");

  const [AuthUser, setAuthUser] = useState("");

  const [BookIDError, setBookIDError] = useState(false);
  const [BookNameError, setBookNameError] = useState(false);
  const [BookTypeError, setBookTypeError] = useState(false);
  const [BookStatusError, setBookStatusError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddBook, setAddBook] = useState({
    BookID: "",
    BookName: "",
    BookType: "",
    BookStatus: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setBookIDD(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const BookData = await GetSingleBook(BookIDD);
        setAddBook({
          BookID: BookData?.BookID,
          BookName: BookData?.BookName,
          BookType: BookData?.BookType,
          BookStatus: BookData?.BookStatus,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, BookIDD]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddBook.BookID === "" ||
      AddBook.BookID === null ||
      AddBook.BookID === undefined
    ) {
      setBookIDError(true);
      flag++;
    } else {
      setBookIDError(false);
    }

    if (
      AddBook.BookName === "" ||
      AddBook.BookName === null ||
      AddBook.BookName === undefined ||
      AddBook.BookName.length < 3
    ) {
      setBookNameError(true);
      flag++;
    } else {
      setBookNameError(false);
    }

    if (
      AddBook.BookType === "" ||
      AddBook.BookType === null ||
      AddBook.BookType === undefined
    ) {
      setBookTypeError(true);
      flag++;
    } else {
      setBookTypeError(false);
    }

    if (
      AddBook.BookStatus === "" ||
      AddBook.BookStatus === null ||
      AddBook.BookStatus === undefined
    ) {
      setBookStatusError(true);
      flag++;
    } else {
      setBookStatusError(false);
    }

    return flag;
  }, [AddBook.BookID, AddBook.BookName, AddBook.BookType, AddBook.BookStatus]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterBook = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const BookFinalObject = {
          ...AddBook,
        };

        await UpdateBook(BookFinalObject, BookIDD)
          .then(() => {
            ToastSuccessMessages("book/update-successful");
            navigate("/user/admin/library");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const BookFinalObject = {
          ...AddBook,
        };

        await CreateBook(BookFinalObject, AuthUser?.uid, SchoolID)
          .then(() => {
            ToastSuccessMessages("book/add-successful");
            navigate("/user/admin/library");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterBook,
    AddBook,
    setAddBook,
    BookIDError,
    BookNameError,
    BookTypeError,
    BookStatusError,
    FormDisabled,
    IsUpdate,
  };
}
